const QUERY_HANDBOOK = {
  sort: '-id',
  'per-page': 20,
  page: 1
}

export {
  QUERY_HANDBOOK
}
